import { render } from "./CartExpiryStoreMessage.vue?vue&type=template&id=6701fb24&scoped=true"
import script from "./CartExpiryStoreMessage.vue?vue&type=script&lang=js"
export * from "./CartExpiryStoreMessage.vue?vue&type=script&lang=js"

import "./CartExpiryStoreMessage.vue?vue&type=style&index=0&id=6701fb24&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6701fb24"]])

export default __exports__